export default __webpack_public_path__ + "static/media/AMZ3.d218e32f.png";